import React from "react";
import { useNavigate } from "react-router-dom";
import { linkOpen } from 'utils/util';
import CmsPreviewShell from "./CmsPreviewShell";

const ShortcutComponent = ({ layout, items = [] }) => {
  const navigate = useNavigate();
  return (
    <CmsPreviewShell>
      <div className={`cms-shortcut cms-shortcut--${layout}`}>
        {items.map((item) => (
          <div key={item.id} className="cms-shortcut__item"
            onClick={()=>{linkOpen(item.link, navigate)}}
          >
            <span className="cms-shortcut__icon">
              {typeof item.icon === "string" && item.icon.startsWith("http") ? (
                <img
                  className="cms-shortcut__icon-img"
                  src={item.icon}
                  alt={item.title || ""}
                />
              ) : (
                item.icon
              )}
            </span>
            <span className="cms-shortcut__label">{item.title}</span>
          </div>
        ))}
      </div>
    </CmsPreviewShell>
  );
};

export default ShortcutComponent;
